import { useQuery } from '@tanstack/react-query';
import { getInvoiceUnitsMeasurement } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvoiceUnitsMeasurement(options = {}) {
    const { data: invoiceUnitsMeasurement = [], isLoading } = useQuery({
        queryKey: ['invoice-units-measurement'],
        queryFn: getInvoiceUnitsMeasurement,
        onError: (error) => trackError(error),
        ...options,
    });

    return {
        invoiceUnitsMeasurement,
        isLoading,
    };
}
